import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
export function BrowserWindow(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className, _host = param.host, host = _host === void 0 ? "example.com" : _host;
    var dot = /*#__PURE__*/ _jsx("span", {
        className: classNames("rounded-full bg-gray-600 dark:bg-gray-600 w-[0.7em]", "h-[0.7em]")
    });
    return /*#__PURE__*/ _jsxs("figure", {
        className: classNames("rounded-b-md relative max-w-full h-auto z-[1]", "shadow-[0_2.75rem_3.5rem_-2rem_rgb(45_55_75_/_20%),_0_0_5rem_-2rem_rgb(45_55_75_/_15%)]", "dark:shadow-[0_2.75rem_3.5rem_-2rem_rgb(0_0_0_/_20%),_0_0_5rem_-2rem_rgb(0_0_0_/_15%)]", "text-xs", className),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: classNames("rounded-t-md relative py-2 px-24 items-center", "flex bg-gray-800 dark:bg-gray-700"),
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: classNames("top-0 left-4 items-center h-full flex absolute", "gap-[0.5em]"),
                        children: [
                            dot,
                            dot,
                            dot
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: classNames("w-full truncate text-gray-400 justify-center", "items-center h-full flex bg-gray-700 dark:text-gray-400", "dark:bg-gray-600"),
                        children: host
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "rounded-b-md flex flex-col overflow-hidden",
                children: children
            })
        ]
    });
}
